export default __webpack_public_path__ + "static/media/complementary--keep-left--g1.9f4023c8.png";